import {useEffect} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {toast} from 'react-toastify'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {getBreadCrumbs} from '../../breadcrumbs'
import {postSelfCare} from '../../../../modules/services/self-care.service'
import {useFormik} from 'formik'
import {InputDefault} from '../../../../components/ui'
import {initialValueMock} from '../../../../mocks'

const SelfCareCreatePage = () => {
  const queryClient = useQueryClient()
  const mutation = useMutation(postSelfCare, {
    onSuccess: async () => {
      toast.success('Create Data Success')
      await queryClient.invalidateQueries('getListSelfCare')
    },
    onError(error: any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  const formik = useFormik({
    initialValues: initialValueMock.cycle,
    onSubmit: (values) => {
      mutation.mutate(values)
    },
  })

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])
  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Create Self Care</p>
          </div>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className='d-flex flex-column align-items-center gap-4 px-8'>
            <div className='w-100'>
              <label htmlFor='cycle' className='form-label'>
                Cycle
              </label>
              <InputDefault
                type='number'
                id='cycle'
                name='cycle'
                value={formik.values.cycle}
                onChange={formik.handleChange}
              />
            </div>
            <div className='w-100'>
              <label htmlFor='name' className='form-label'>
                Name
              </label>
              <InputDefault
                type='text'
                id='name'
                name='name'
                value={formik.values.name}
                onChange={formik.handleChange}
              />
            </div>
            <div className='w-100'>
              <label htmlFor='description' className='form-label'>
                Description
              </label>
              <InputDefault
                type='text'
                id='description'
                name='description'
                value={formik.values.description}
                onChange={formik.handleChange}
              />
            </div>
          </div>
          <div className='d-flex justify-content-end p-8 gap-4'>
            <button type='button' className='btn btn-light'>
              Cancel
            </button>
            <button disabled={formik.isSubmitting} type='submit' className='btn btn-primary'>
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

const SelfCareCreateWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('/self-care-plan/self-care')}>
        Create Self Care
      </PageTitle>
      <SelfCareCreatePage />
    </>
  )
}

export default SelfCareCreateWrapper
